module.exports = __webpack_public_path__ + "static/media/email.dc382484.svg";